<div class="gd-label-value-container tw-flex tw-flex-col" [dir]="dir$ | async">
  <!-- TODO remove this -->
  <!-- <h4 *ngIf="options.inputType === 'radio-button' || options.inputType === 'checkbox'">Options</h4> -->

  <div [formGroup]="createForm"
    class="gd-label-value-form-wrapper {{formClasses}} tw-flex tw-flex-row tw-items-start tw-gap-2.5">
    <mat-form-field class="input-field"
                    appearance="outline">
      <input matInput
        type="text"
        formControlName="label"
        autocomplete="off">
        <mat-label>{{ keyLabel }}</mat-label>
        @if (createForm.get('label').hasError('required')) {
          <mat-error>
            {{ keyLabel }} <span i18n>is a required field</span>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="input-field --last"
        appearance="outline">
        <input matInput
          type="text"
          formControlName="value"
          autocomplete="off">
          <mat-label>{{ valueLabel }}</mat-label>
          @if (createForm.get('value').hasError('required')) {
            <mat-error>
              {{ valueLabel }} <span i18n>is a required field</span>
            </mat-error>
          }
        </mat-form-field>

        <div class="gd-label-value-form-add-btn tw-flex tw-flex-100 tw-max-w-[150px] tw-h-10 tw-items-center">
          <button
            mat-raised-button
            (click)="addItem()"
            color="accent"
            [disabled]="!hasActionPermission">
            <mat-icon>add</mat-icon><span i18n>Add</span>
          </button>
        </div>
      </div>

      @if (listData && listData.length!==0) {
        <mat-table cdkDropList
          (cdkDropListDropped)="handleDropEvent($event)"
          [dataSource]="listData"
          class="gd-label-value-form__table"
          [cdkDropListDisabled]="!hasActionPermission">
          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef>{{ keyLabel }}</mat-header-cell>
            <mat-cell *matCellDef="let style;"
              class="table-cell">{{style.label}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef>{{ valueLabel }}</mat-header-cell>
            <mat-cell *matCellDef="let style;"
              class="table-cell"> <span class="ellipsis">{{style.value}}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="controls">
            <mat-header-cell *matHeaderCellDef
            class="tw-flex-100 tw-max-w-[200px]"></mat-header-cell>
            <mat-cell *matCellDef="let style; let i = index"
              class="tw-flex tw-flex-100 tw-max-w-[200px] tw-justify-end tw-items-center tw-gap-2.5">
              <button class="gd-item-list__button"
                mat-icon-button
                type="button"
                (click)="copyItemValue(i)">
                <mat-icon fontSet="fal" fontIcon="fa-copy"></mat-icon>
              </button>
              <button class="gd-item-list__button"
                mat-icon-button
                type="button"
                (click)="editItem(i)"
                [disabled]="!hasActionPermission">
                <mat-icon>create</mat-icon>
              </button>
              <button class="gd-item-list__button"
                mat-icon-button
                type="button"
                (click)="removeItem(i)"
                [disabled]="!hasActionPermission">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row cdkDrag *matRowDef="let row; columns: displayedColumns;"
          class="gd-item-list__row"></mat-row>
        </mat-table>
      }
    </div>
